import { post, get, put, deleteApi } from '../axiosFun'
/* 培训人员 */
// 分页
const traineePage = (data) => {
    return post('/train/trainee-rec/page', data)
}
const traineeAdd = (data) => {
    return post('/train/trainee-rec/add', data)
}
// 导出
const traineeExport = (data) => {
    return post('/train/trainee-rec/export', data, {
        responseType: 'blob',
        isExport: false,
    })
}
// 删除
const traineeRemove = (data, planId) => {
    return deleteApi('/train/trainee-rec/remove/' + planId, data)
}
export default {
    traineePage,
    traineeExport,
    traineeRemove,
    traineeAdd,
}



// WEBPACK FOOTER //
// ./src/api/onlineTraining/traineeRec.js